import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import ChangeEmail from './components/ChangeEmail';
import ChangeEmailConfirmation from './components/ChangeEmailConfirmation';
import ResetPassword from './components/ResetPassword';
import ResetPasswordConfirmation from './components/ResetPasswordConfirmation';

import './App.css';

class DebugRouter extends Router {
  constructor(props){
      super(props);
          console.log('initial history is: ', JSON.stringify(this.history, null,2))
              this.history.listen((location, action)=>{
                    console.log(
                            `The current URL is ${location.pathname}${location.search}${location.hash}`
                                  )
                                        console.log(`The last navigation action was ${action}`, JSON.stringify(this.history, null,2));
                                            });
                                              }
                                              }

const App = () => (
    <DebugRouter basename={'/account-management'}>
            <Route path='/change-email' component={ChangeEmail}/>
                    <Route exact path='/change-email-confirmation/:token' component={ChangeEmailConfirmation}/>
                            <Route path='/reset-password' component={ResetPassword}/>
                                    <Route exact path='/reset-password-confirmation/:token' component={ResetPasswordConfirmation}/>
    </DebugRouter>
);

export default App;
